/**
 * 塔罗牌 API
 * - 抽牌逻辑在前端（保留）
 * - 解读调用后端统一 AI 服务
 */
import api, { aiApi } from '@/api/client'

const API_BASE = '/api/ai' 

// 大阿卡纳牌组（22张）
const majorArcana = [
  { name: '愚者', number: 0, suit: 'major', meaning: '开始、纯真、自发' },
  { name: '魔术师', number: 1, suit: 'major', meaning: '创造、技能、意志力' },
  { name: '女祭司', number: 2, suit: 'major', meaning: '直觉、神秘、内在知识' },
  { name: '女皇', number: 3, suit: 'major', meaning: '丰收、母性、创造力' },
  { name: '皇帝', number: 4, suit: 'major', meaning: '权威、建立、成就' },
  { name: '教皇', number: 5, suit: 'major', meaning: '指导、信仰、传统' },
  { name: '恋人', number: 6, suit: 'major', meaning: '选择、爱情、和谐' },
  { name: '战车', number: 7, suit: 'major', meaning: '控制、意志、胜利' },
  { name: '力量', number: 8, suit: 'major', meaning: '勇气、耐心、同情' },
  { name: '隐士', number: 9, suit: 'major', meaning: '内省、寻求、指导' },
  { name: '命运之轮', number: 10, suit: 'major', meaning: '改变、机会、命运' },
  { name: '正义', number: 11, suit: 'major', meaning: '公平、真理、因果' },
  { name: '倒吊人', number: 12, suit: 'major', meaning: '牺牲、释放、新视角' },
  { name: '死神', number: 13, suit: 'major', meaning: '结束、改变、转变' },
  { name: '节制', number: 14, suit: 'major', meaning: '平衡、调和、目的' },
  { name: '恶魔', number: 15, suit: 'major', meaning: '束缚、欲望、执着' },
  { name: '塔', number: 16, suit: 'major', meaning: '突变、启示、解放' },
  { name: '星星', number: 17, suit: 'major', meaning: '希望、启发、宁静' },
  { name: '月亮', number: 18, suit: 'major', meaning: '幻觉、恐惧、潜意识' },
  { name: '太阳', number: 19, suit: 'major', meaning: '快乐、活力、成功' },
  { name: '审判', number: 20, suit: 'major', meaning: '重生、内在呼唤、觉醒' },
  { name: '世界', number: 21, suit: 'major', meaning: '完成、整合、成就' }
]

// 小阿卡纳 - 权杖（Wands）- 火元素
const wandsMinor = [
  { name: '权杖一', number: 1, suit: 'wands', meaning: '新开始、灵感、潜力' },
  { name: '权杖二', number: 2, suit: 'wands', meaning: '计划、决策、未来愿景' },
  { name: '权杖三', number: 3, suit: 'wands', meaning: '扩张、远见、合作' },
  { name: '权杖四', number: 4, suit: 'wands', meaning: '庆祝、和谐、稳定' },
  { name: '权杖五', number: 5, suit: 'wands', meaning: '冲突、竞争、挑战' },
  { name: '权杖六', number: 6, suit: 'wands', meaning: '胜利、荣誉、认可' },
  { name: '权杖七', number: 7, suit: 'wands', meaning: '防御、坚持、立场' },
  { name: '权杖八', number: 8, suit: 'wands', meaning: '速度、行动、快速变化' },
  { name: '权杖九', number: 9, suit: 'wands', meaning: '坚韧、毅力、防守' },
  { name: '权杖十', number: 10, suit: 'wands', meaning: '负担、责任、压力' },
  { name: '权杖侍从', number: 11, suit: 'wands', meaning: '探索、热情、新消息' },
  { name: '权杖骑士', number: 12, suit: 'wands', meaning: '冒险、冲动、追求' },
  { name: '权杖王后', number: 13, suit: 'wands', meaning: '自信、独立、决心' },
  { name: '权杖国王', number: 14, suit: 'wands', meaning: '领导、远见、创业' }
]

// 小阿卡纳 - 圣杯（Cups）- 水元素
const cupsMinor = [
  { name: '圣杯一', number: 1, suit: 'cups', meaning: '新感情、爱、直觉' },
  { name: '圣杯二', number: 2, suit: 'cups', meaning: '合作、连接、吸引' },
  { name: '圣杯三', number: 3, suit: 'cups', meaning: '友谊、庆祝、社交' },
  { name: '圣杯四', number: 4, suit: 'cups', meaning: '冷漠、不满、冥想' },
  { name: '圣杯五', number: 5, suit: 'cups', meaning: '失落、悲伤、失望' },
  { name: '圣杯六', number: 6, suit: 'cups', meaning: '回忆、童年、怀旧' },
  { name: '圣杯七', number: 7, suit: 'cups', meaning: '幻想、选择、迷惑' },
  { name: '圣杯八', number: 8, suit: 'cups', meaning: '离开、放弃、寻找' },
  { name: '圣杯九', number: 9, suit: 'cups', meaning: '满足、愿望成真、感恩' },
  { name: '圣杯十', number: 10, suit: 'cups', meaning: '幸福、家庭、和谐' },
  { name: '圣杯侍从', number: 11, suit: 'cups', meaning: '敏感、直觉、新情感' },
  { name: '圣杯骑士', number: 12, suit: 'cups', meaning: '浪漫、追求、梦想' },
  { name: '圣杯王后', number: 13, suit: 'cups', meaning: '同理心、直觉、关怀' },
  { name: '圣杯国王', number: 14, suit: 'cups', meaning: '情感成熟、智慧、平静' }
]

// 小阿卡纳 - 宝剑（Swords）- 风元素
const swordsMinor = [
  { name: '宝剑一', number: 1, suit: 'swords', meaning: '突破、清晰、新想法' },
  { name: '宝剑二', number: 2, suit: 'swords', meaning: '僵局、选择、回避' },
  { name: '宝剑三', number: 3, suit: 'swords', meaning: '心痛、悲伤、分离' },
  { name: '宝剑四', number: 4, suit: 'swords', meaning: '休息、恢复、沉思' },
  { name: '宝剑五', number: 5, suit: 'swords', meaning: '冲突、失败、自私' },
  { name: '宝剑六', number: 6, suit: 'swords', meaning: '过渡、改变、离开' },
  { name: '宝剑七', number: 7, suit: 'swords', meaning: '欺骗、策略、隐秘' },
  { name: '宝剑八', number: 8, suit: 'swords', meaning: '束缚、限制、困境' },
  { name: '宝剑九', number: 9, suit: 'swords', meaning: '焦虑、噩梦、担忧' },
  { name: '宝剑十', number: 10, suit: 'swords', meaning: '结束、背叛、痛苦终结' },
  { name: '宝剑侍从', number: 11, suit: 'swords', meaning: '好奇、观察、新想法' },
  { name: '宝剑骑士', number: 12, suit: 'swords', meaning: '直接、果断、行动' },
  { name: '宝剑王后', number: 13, suit: 'swords', meaning: '独立、清晰、理性' },
  { name: '宝剑国王', number: 14, suit: 'swords', meaning: '权威、判断、真理' }
]

// 小阿卡纳 - 星币（Pentacles）- 土元素
const pentaclesMinor = [
  { name: '星币一', number: 1, suit: 'pentacles', meaning: '新机会、财富、物质开始' },
  { name: '星币二', number: 2, suit: 'pentacles', meaning: '平衡、适应、灵活性' },
  { name: '星币三', number: 3, suit: 'pentacles', meaning: '合作、技能、学习' },
  { name: '星币四', number: 4, suit: 'pentacles', meaning: '控制、安全、保守' },
  { name: '星币五', number: 5, suit: 'pentacles', meaning: '困难、缺乏、困境' },
  { name: '星币六', number: 6, suit: 'pentacles', meaning: '慷慨、分享、给予' },
  { name: '星币七', number: 7, suit: 'pentacles', meaning: '耐心、评估、等待' },
  { name: '星币八', number: 8, suit: 'pentacles', meaning: '勤奋、技艺、专注' },
  { name: '星币九', number: 9, suit: 'pentacles', meaning: '富足、独立、享受' },
  { name: '星币十', number: 10, suit: 'pentacles', meaning: '财富、家族、传承' },
  { name: '星币侍从', number: 11, suit: 'pentacles', meaning: '学习、机会、新技能' },
  { name: '星币骑士', number: 12, suit: 'pentacles', meaning: '稳定、勤奋、可靠' },
  { name: '星币王后', number: 13, suit: 'pentacles', meaning: '务实、富足、滋养' },
  { name: '星币国王', number: 14, suit: 'pentacles', meaning: '财富、成功、事业' }
]

// 合并所有牌组
const minorArcana = [...wandsMinor, ...cupsMinor, ...swordsMinor, ...pentaclesMinor]
const getTarotDeck = (includeMinor = true) => includeMinor ? [...majorArcana, ...minorArcana] : [...majorArcana]

// 牌阵配置
const spreadConfigs = {
  single: { name: '单张牌阵', positions: ['当前形势'], heroIndex: 0, description: '简单直接，适合快速了解整体趋势', cardCount: 1 },
  three: { name: '三张牌阵', positions: ['过去', '现在', '未来'], heroIndex: 1, /* 时间线牌阵主牌=现在 */ description: '时间线牌阵，了解事件发展脉络', cardCount: 3 },
  celtic: { name: '凯尔特十字', positions: ['当前处境', '当前挑战', '过去基础', '即将过去', '最高期望', '近期发展', '自我认知', '外在环境', '希望恐惧', '最终结果'], heroIndex: 0, description: '经典牌阵，全面深入分析问题', cardCount: 10 },
  quarter: { name: '四季牌阵', positions: ['核心指引', '火元素-行动', '水元素-情感', '风元素-思想', '土元素-物质'], heroIndex: 0, description: '从精神和物质层面全面解读，适合季度运势', cardCount: 5, special: true }
}

// 抽取塔罗牌
const drawTarotCards = (spread) => {
  const config = spreadConfigs[spread] || spreadConfigs.single
  
  // 四季牌阵特殊处理
  if (config.special && spread === 'quarter') {
    const positions = config.positions
    const drawnCards = []
    
    // 第一张：大阿卡纳
    const majorDeck = [...majorArcana]
    const majorIndex = Math.floor(Math.random() * majorDeck.length)
    drawnCards.push({ ...majorDeck[majorIndex], position: positions[0], reversed: Math.random() < 0.5 })
    
    // 后四张：四种花色各一张
    const suits = [wandsMinor, cupsMinor, swordsMinor, pentaclesMinor]
    for (let i = 0; i < 4; i++) {
      const suitDeck = [...suits[i]]
      const suitIndex = Math.floor(Math.random() * suitDeck.length)
      drawnCards.push({ ...suitDeck[suitIndex], position: positions[i + 1], reversed: Math.random() < 0.5 })
    }
    return drawnCards
  }
  
  // 普通牌阵
  const allCards = getTarotDeck(true)
  const drawnCards = []
  
  for (let i = 0; i < config.positions.length; i++) {
    const randomIndex = Math.floor(Math.random() * allCards.length)
    drawnCards.push({ ...allCards[randomIndex], position: config.positions[i], reversed: Math.random() < 0.5 })
    allCards.splice(randomIndex, 1)
  }
  return drawnCards
}

// 获取牌阵信息
const getSpreadInfo = (spread) => spreadConfigs[spread] || spreadConfigs.single

// 塔罗牌解读 API - 调用后端
// cards 参数可选：如果不传则自动抽牌，如果传了则使用传入的牌
const analyzeTarotReading = async ({ question, spread, cards: providedCards }) => {
  try {
    const cards = providedCards || drawTarotCards(spread)
    const spreadInfo = getSpreadInfo(spread)
    
    // api 响应拦截器已拆包 response.data，所以 result 直接可用
    const response = await aiApi.post(`${API_BASE}/tarot`, { question, spread, cards })
    return { cards, spread: spreadInfo, data: response.result }
  } catch (error) {
    console.error('塔罗牌解读失败:', error)
    throw error
  }
}

export { 
  majorArcana, minorArcana, wandsMinor, cupsMinor, swordsMinor, pentaclesMinor,
  getTarotDeck, drawTarotCards, getSpreadInfo, spreadConfigs, analyzeTarotReading 
}
